export const API = {
  AUTH_DEV: {
    LOGIN: '/dev/login',
    REFRESH: '/dev/refresh/'
  },
  AUTH: {
    LOGIN: '/user/login',
    // session-aware endpoints: refresh needs the sid + jid cookies, logout revokes the session
    REFRESH: '/user/refresh/new',
    LOGOUT: '/user/logout/new',
    REGISTER: '/business/signup',
    VERIFY: '/user/verifyEmail/',
    SIGNUP_WITH_PLAN: '/business/signupWithPlan'
  },
  LOCATION: {
    FIND_BY_ID: '/location/findById/',
    ADD_LOCATION: '/location/add',
    UPDATE_LOCATION: '/location/update',
    DELETE: '/location/delete/',
    LOCATION_ELIGILIBILITY: '/location/checkLocationEligibility/'
  },
  customer_appointment: {
    ALL_LOCATIONS: '/location/findAll',
    AVALIABLE_SLOTS_BY_DATE: 'appointment/getAvaliableSlotsByDate',
    AVALIABLE_SLOTS_BY_DATE_V3: '/appointment/public/getAvaliableSlotsByDateV3',
    AVALIABLE_SLOTS_BY_DATE_FOR_ADMIN: 'appointment/getSlotsForAdmin',
    // Flow-aware: serviceId / professionalId / professionalServiceId per the location's booking flow
    AVALIABLE_SLOTS_BY_DATE_FOR_ADMIN_V3: 'appointment/getSlotsForAdminV3',
    CREATE_APPOINMNET: '/appointment/public/create',
    CREATE_APPOINMNET_BOOKINGID: '/appointment/public/take-payment',
    APPOINMNET_SUMMARY: '/appointment/public/appointmentSummary/',
    CREATE_APPOINMENT_FROM_DAHBOARD: '/appointment/add',
    UPDATE_APPOINMENT_FROM_DAHBOARD: '/appointment/update',
    APPOINTMENT_WITHOUT_PAYMENT: '/appointment/public/create/no-payment',
    ALL_LOACTION_SUBDOMAIN: '/business/findBySubdomain/',
    BUSINESS_BY_SLUG: '/business/findBySlug/',
    CHECK_APPOINTMENT_AVALIABILITY: '/appointment/checkIfSlotBooked',
    CHECK_APPOINTMENT_PAID: '/appointment/checkIfPaid',
    PAGE_CONTENT: '/location/getBookingPageContent/',
    ADD_PAGE_CONTENT: '/location/updateLeftContentForBookingPage',
    ADD_PAGE_RIGHT_CPNTENT: '/location/updateRightContentForBookingPage',
    PROVISIONAL_BOOKING: '/appointment/getProvisionalBooking/',
    UPDATE_APPOINTMENT_WITHOUT_PAYMENT: '/appointment/public/updateAppointment',
    CUSTOMER_INFORMATION_BY_APPOINTMENT_ID: '/appointment/public/getCustomerInformation/'
  },
  WORKING_DAYS: {
    ALL_WORKING_DAYS: 'appointment/getAvaliableDates/',
    ALL_WORKING_DAYS_FOR_ADMIN: 'appointment/getAvailableDatesForAdmin/',
    WORKING_DAYS_BY_LOCATION: '/working-day/findAllByLocation/',
    UPDATE_WORKING_DAYS_BY_LOCATION: '/working-day/update',
    WORKING_DAYS_HISTORY_LOCATION: '/working-day-history/findAllByLocation/'
  },
  SERVICES: {
    ALL_SERVICES: 'service/findAllByLocation/',
    ADD_SERVICE: '/service/add',
    DELETE_SERVICE: '/service/delete/',
    UPDATE_SERVICE: '/service/update',
    UPDATE_STATUS: '/service/update',
    ALL_SERVICE_WITHOUT_FILTER: 'service/findByLocation/',
    BACK_OFFICE: '/service/findForBackOffice/'
  },
  CATEGORY: {
    ALL_CATEGORIES: '/category/findAllByLocation/',
    ADD_CATEGORY: '/category/add',
    UPDATE_CATEGORY: '/category/update',
    DELETE_CATEGORY: '/category/delete/'
  },
  SESSIONS: {
    ME: '/sessions/me',
    BY_BUSINESS_LOCATION: '/sessions/by-business-location',
    LOGOUT_OWN: '/sessions/make/logout/',
    REVOKE: '/sessions/revoke/session/'
  },
  AUDIT_LOG: {
    ALL_WITH_PAGINATION: '/audit-log/findAllWithPagination',
    BY_BUSINESS_AND_LOCATION: '/audit-log/findAllByBusinessAndLocation'
  },
  PROFESSIONAL: {
    ALL_PROFESSIONALS: '/professional/findAllByLocation/',
    ADD_PROFESSIONAL: '/professional/add',
    UPDATE_PROFESSIONAL: '/professional/update',
    DELETE_PROFESSIONAL: '/professional/delete/',
    // `/professional/service/:serviceId[/link]`
    BY_SERVICE: '/professional/service/',
    // `/professional/:professionalId/working-hours`
    BASE: '/professional/'
  },
  FLOW: {
    // `/flow/:locationId` (GET load, POST save/publish), `/flow/:locationId/slug`
    // and `/flow/:locationId/rules`
    BASE: '/flow/'
  },
  PROFESSIONAL_SERVICE: {
    ADD: '/professional-service/add',
    UPDATE: '/professional-service/update',
    DELETE: '/professional-service/delete/',
    // `/professional-service/findAll/:professionalId/:locationId`
    FIND_ALL: '/professional-service/findAll/'
  },
  PUBLIC: {
    // `/public/flow/:slug` and `/public/flow/:slug/service/:serviceId/professionals`
    FLOW_BY_SLUG: '/public/flow/',
    // `/public/location/:locationId/slug`
    LOCATION: '/public/location/',
    // `/public/professional-service/:professionalId/:locationId`
    PROFESSIONAL_SERVICES: '/public/professional-service/',
    // `/appointment/public/details?appointmentId=`
    APPOINTMENT_DETAILS: '/appointment/public/details'
  },
  PATIENTS: {
    ADD_PATIENT: '/customer/add',
    GET_PATIENT: '/customer/findAll/',
    GET_PATIENT_BY_ID: '/customer/findById/',
    UPDATE_PATIENT: '/customer/update',
    DELETE_PATIENT: '/customer/delete/',
    TEMP_PATIENT: '',
    PAGINATION_PATIENTS: '/customer/findAllWithPagination',
    PAGINATION_SEARCH: '/customer/searchWithPagination',
    APPOINTMENTS_NOTES: '/notes/findAllByAppointment/',
    CUSTOMER_NOTES: '/notes/findAllByCustomer/',
    ADD_NOTES: '/notes/add',
    DELETE_NOTES: '/notes/delete/',
    UPDATE_NOTES: '/notes/update',
    CONVERSTAION_LOGS: '/communication-timeline/findAllByCustomerId/'
  },
  TIMEOFFS: {
    ADD: '/time-off/add',
    UPDATE: 'time-off/update',
    DELETE: 'time-off/delete/',
    GET_ALL_BY_LOCATION: '/time-off/findAll/'
  },
  OAUTH: {
    CREATE_SQUARE_PAYMENT_ACCOUNT: '/payment-accounts/add',
    GET_ALL_SQUARE_PAY_LOCATION: '/square/findAllSquareLocations/',
    BIND_SQUARE_LOCATION: '/payment-accounts/bind-square-location/',
    CHECK_SQUARE_CONNECTED: '/payment-accounts/isSquareConnected/',
    DISCONNECT_SQUARE: '/payment-accounts/deleteSquareAccount/',
    DISCONNECT_GOOGLE_CALENDAR: '/google-calendar/account/disconnect/',
    CHECK_GOOGLE_CALENDAR_CONNECTED: '/google-calendar/account/isConnected/',
    CHECK_MICROSOFT_CONNECTED: '/microsoft-calendar/account/isConnected/',
    DISCONNECT_MICROSOFT_CALENDAR: '/microsoft-calendar/account/disconnect/',
    CHECK_PAYMENT_PROVIDER: '/payment-accounts/connected/',
    CONNECT_STRIPE: '/stripe/connect',
    CHECK_CURRENT_ACCOUNT: '/payment-accounts/current-connected/',
    STRIPE_INTENT: '/stripe/appointment/payment-intent',
    DISCONNECT_PAYMENT_ACCOUNT: '/payment-accounts/remove/'
  },
  BREAKS: {
    GET_ALL_BREAKS: '/break/findAll/',
    ADD_BREAK: '/break/add',
    REMOVE_BREAK: '/break/delete/',
    BREAKS_HISTORY: '/break/findAllHistory/'
  },
  APPOINTMENT: {
    GET_APPOINTMENT_BY_LOCATION: 'appointment/findAllByLocation/',
    CHANGE_APPOINTMENT_STATUS: '/appointment/change-status/',
    CANCEL_APPOINTMENT: '/appointment/cancel/',
    PAGINATION_APPOINTMENTS: '/appointment/getAllByLocationWithPagination',
    PAGINATION_APPOINTMENTS_SEARCH: '/appointment/searchWithPagination',
    GET_APPOINTMENT_BY_YEAR_MONTH: '/appointment/findAllByYearMonth/',
    DELETE: '/appointment/delete/',
    CHECK_TAB_VISIBILITY: '/appointment/checkDetails/',
    BY_ID: '/appointment/findById/',
    BULK_UPDATE_STATUS: '/appointment/bulkUpdateStatus',
    CONVERSTAION_LOGS: '/communication-timeline/findAllByAppointmentId/',
    TODAY_APPOINTMENT_DATA: '/dashboard/reportSmsAndEmail/',
    SMS_EMAIL_REPORT: '/dashboard/smsAndEmailReport/',
    BULK_REVIEW_EMAIL: '/appointment/bulkReviewEmail',
    MARK_APPOINTMENT_AS_PAID: '/appointment/markAsPaid',
    DELETE_GOOGLE_APPOINTMENT: '/google-calendar/delete/',
    APP_FEE_DATA: '/dashboard/allTimeAppFeeReport',
    ALLOW_BLOCKING_GOOGLE_EVENT: '/google-calendar/mark-is-eligible-for-blocking/',
    DELETE_MICROSOFT_APPOINTMENT: '/microsoft-calendar/delete/',
    ALLOW_BLOCKING_MICROSFT_EVENT: '/microsoft-calendar/mark-is-eligible-for-blocking/'
  },
  GTM: {
    GET_GTM_ID: 'google-tag-manager/findByLocation/',
    ADD_GTM_ID: 'google-tag-manager/create',
    UPDATE_GTM_ID: 'google-tag-manager/edit',
    IS_CONNECTED: '/google-tag-manager/isGoogleTagManagerConnected/'
  },
  ADMIN: {
    ADD_ADMIN: '/user/register/admin',
    UPDATE_ADMIN: '/user/profile/update',
    GET_ALL_ADMIN: '/user/findAllAdminsAndBusinessAdminsByLocation/',
    DELETE_ADMIN: '/user/delete/',
    CHANGE_APPOINTMENT_STATUS: '/appointment/change-status/',
    CANCEL_APPOINTMENT: '/appointment/cancel/',
    FREEZE_ADMIN: '/user/updateStatus/',
    RESET_ADMIN: '/user/sendPasswordResetEmail/',
    UPDATE_EMAIL: '/user/email/update',
    VERIFY_EMAIL_REQUEST: '/user/email/change/verify',
    VERIFY_ADMIN: '/user/invite/verify',
    RESEND_INVITATION: '/user/resend-invitation',
    GET_PLATFORM_AND_SUPER_ADMINS: 'user/findAllSuperAndPlatformAdmins'
  },
  PAYEMNT_TRANSACTIONS: {
    GET_ALL_PAYMENTS: '/paymentTransaction/getAllByLocation/',
    PAGINATION_PAYEMNTS: '/paymentTransaction/getAllByLocationWithPagination',
    PAGINATION_LOGS: '/paymentLog/findAllByLocation',
    PAGINATION_PAYMENT_LOG_SEARCH: '/paymentLog/searchWithPagination',
    PAYMENT_HISTORY_SEARCH: '/paymentTransaction/searchWithPagination',
    ALL_PAGINATION_LOGS: '/paymentLog/findAllWithPagination',
    ALL_PAGINATION_PAYMENT_LOG_SEARCH: '/paymentLog/findAllByLocation'
  },
  REFUND: {
    CLAIM_REFUND: '/refund/issue',
    REFUNDS_LIST: '/refund/findAllByPaymentTransaction/',
    PAGINATION_REFUNDS: '/refund/findAllByLocation',
    PAGINATION_REFUNDS_SEARCH: '/refund/searchWithPagination'
  },
  BOOKING_POLICIES: {
    GET_POLICIES: '/location/findById/',
    ADD_POLICIES: '/location/changeCancellationPolicy',
    ADD_WINDOW_SIZE: '/location/changeScheduleWidowSize',

    ADD_EMAIL_SCHEDULER: '/location/updateCustomerReminderTime',
    DOUBLE_BOOKINGS: '/location/updateDoubleBookingSettings',
    TIME_FORMAT: '/location/updateSlotsFormat',
    APPOINTMENT_JOURNEY: '/location/updateAppointmentJourney',
    ADD_PAST_WINDOW_SIZE: '/location/changeBackDateScheduleSize/',
    EMAIL_SENDER_NAME: '/location/updateEmailSenderName/'
  },
  NOTIFICATIONS: {
    GET_ALL_NOTFICATIONS: '/notifications/findAllByLocation/',
    MARK_ALL_NOTIFICATIONS_READ: '/notifications/markAllRead'
  },
  CANCELLATION: {
    GET_BYLOCATION: '/location/findCancellationPolicy/',
    ADD_POLICY: '/location/updateTermsAndConditions',
    GET_POLICY: '/location/findById/'
  },
  PROFILE: {
    GET: '/user/profile/',
    UPDATE: '/user/updateProfile',
    CHANGE_PASSWORD: '/user/change-password'
  },
  BUSINESS: {
    GET: '/business/findAllWithLocations',
    ADD: '/business/registerNew',
    BY_ID: '/business/findById/',
    DELETE: '/business/delete/',
    UPDATE: '/business/update',
    SUBDOMAINS_LIST: '/business/subdomains/all',
    FINALIZE_DETAILS: '/business/finalize-details'
  },
  PAYMENT_LOGS: {
    GET: '/paymentLog/findAllByAppointment/'
  },
  DASHBOARD: {
    LOCATION_ADMIN: '/dashboard/v2/forLocation/',
    BUSINESS_ADMIN: '/dashboard/forBusiness/',
    ALL_TIME_REVENUE: '/dashboard/allTimeRevenueReport'
  },
  BUSINESS_REVIEWS: {
    TRUST_PILOT: '/business-reviews/trust-pilot/',
    GOOGLE_CONFIG: '/business-reviews/google-config/',
    PUBLIC_PAGE: '/business-reviews/publicPage/',
    DELETE_GOOGLE: '/business-reviews/delete/google/',
    DELETE_TRUST_PILOT: '/business-reviews/delete/trustPilot/'
  },
  S3: {
    PRESIGNED_URL: '/s3/getUrl/'
  },
  FORGOT_PASSWORD: {
    SEND_PASSWORD: '/user/sendPasswordResetEmail/',
    RESET_PASSWORD: '/user/resetPassword'
  },
  EMAIL_TEMPLATE: {
    EMAIL_GET: '/email-templates/findAllByLocation/',
    VARAIABLES: '/email-templates/findAllEmailVariables/',
    SAVE: '/email-templates/update'
  },
  SMS_TEMPLATE: {
    SMS_GET: '/sms/findAllByLocation/',
    VARAIABLES: '/email-templates/findAllEmailVariables/',
    SAVE: '/sms/update'
  },
  APP_FEE: {
    GET_BUSINESS: '/app-fee/findAll',
    UPDATE_BUSINESS_FEE: 'business/updateApplicationFee',
    UPDATE_LOCATION_FEE: '/location/updateApplicationFee',
    GET_DEFAULT_FEE: '/app-settings/findAll',
    UPDATE_DEFAULT_FEE: '/app-settings/update/'
  },
  API_LOGS: {
    GET_LOGS: '/loki/getLogs'
  },
  SUBSCRIPTIONS: {
    GET: '/slot-subscriptions/getAllPlans',
    UPDATE: '/slot-subscriptions/update',
    FEATURE_LIST: '/subscription-plans/getForLandingPage',
    SQUARE_PLAN_GET: '/square-plans/findAllPlans',
    SQUARE_PLAN_ADD: '/square-plans/plan/add',
    SQUARE_PLAN_VARAITION: '/square-plans/plan-variation/add',
    SQUARE_PLAN_STATUS_UPDATE: '/square-plans/plan/delete',
    SELECT_PLAN_FOR_SLOT: '/square-plans/select-square-plan',
    GET_USER_PLAN: '/subscriptions/find-details-by-userId',
    ADD_PLAN: '/subscription-plans/add',
    GET_PLAN: '/subscription-plans/findAllPlans',
    DELETE_PLAN: '/subscription-plans/delete',
    UPDATE_PLAN: '/subscription-plans/update',
    UPDATE_CARD: '/card/addNew',
    GET_USER_CARD: '/card/findByUserId',
    UPGRADE_SUB_PLAN: '/subscriptions/upgradeSubscription'
  },
  AVAILABILITY_REMINDER: {
    FIND_BY_LOCATION: '/availability-alerts/',
    UPSERT: '/availability-alerts'
  },
  DENTALLY: {
    CONNECT: '/dentally-location/connect/',
    DISCONNECT: '/dentally-location/disconnect/',
    CHECK_CONNECTED: '/dentally-location',
    GET_SERVICES: '/dentally/getServices',
    GET_LOCATIONS: '/dentally/getLocations',
    MAP_LOCATIONS: '/dentally/mapLocations',
    GET_DENTALLY_SITES: '/dentally-location/sites',
    BIND_SITE_PRACTITIONER: '/dentally-location/bind/site-practitioner',
    GET_PRACTITIONERS: '/dentally-location/practioners',
    GET_REASONS_MAPPING: '/dentally-location/reasons-mapping',
    MAP_SERVICES: '/dentally-location/update/service-mapping/',
    GET_CUSTOM_FIELDS: '/dentally-location',
    UPDATE_CREATE_PATIENT_PARAMS: '/dentally-location/update/create-patient/parameters',
    GET_PAYMENT_PLANS: '/dentally-location/payment-plans',
    GET_STATUS: 'dentally-location/status/',
    TOGGLE_STATUS: '/dentally-location/toggle-status/',
    GET_LOGS_BY_LOCATION: '/dentally-logs/',
    RETRY_CREATE_APPOINTMENT: '/dentally-logs/retry/create-appointment/'
  }
};
